import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import showConsoleBanner from './utils/banner';
import { disableConsole, detectDevTools } from './utils/consoleProtection';

// Protección de consola en producción
disableConsole();
detectDevTools();

// Mostrar banner en la consola
showConsoleBanner();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
